import React, { createContext, useContext } from 'react';
import { toast } from 'react-toastify';

const ToastContext = createContext();

export const ToastProvider = ({ children }) => {

    // نمایش پیام‌های مختلف (موفقیت، خطا، هشدار)
    const showMessage = (type, message, duration = 5000, toastId = 0) => {
        
        if (toastId !== 0) {
            // اگر toastId موجود باشد، پیام را به‌روزرسانی می‌کنیم (برای لودینگ یا خطا)
            toast.update(toastId, {
                render: message,
                type: type, // نوع پیام (موفقیت، خطا، هشدار)
                isLoading: false, // لودینگ را غیرفعال می‌کنیم
                autoClose: duration,
                className: type === 'error' ? 'toast-error' : 'toast-success',
            });
        } else {
            // در غیر اینصورت پیام جدید نمایش داده می‌شود
            toast[type](message, { autoClose: duration ,className: type === 'error' ? 'toast-error' : 'toast-success' });
        }
    };

    // نمایش لودینگ و دریافت شناسه آن
    const showLoading = (message) => {
        const id = toast.loading(message);
        return id; // شناسه لودینگ را برمی‌گرداند
    };

    return (
        <ToastContext.Provider value={{ showMessage, showLoading }}>
            {children}
        </ToastContext.Provider>
    );
};

export const useToast = () => useContext(ToastContext);
